import * as React from 'react';
import { UIView } from '@uirouter/react';

import AuthService from '../../global/authService';
import AppConfig from '../../global/appConfig';

/**
 * This is the main app component for an authenticated user.
 *
 * This component renders the outermost chrome (application header and tabs, the compose  and logout button)
 * It has a `UIView` viewport for nested states to fill in.
 */
export class App extends React.Component<{transition: any}> {
    constructor (props: any) {
        super(props);
        AppConfig.load();
    }

    handleLogout = () => {
        const {transition} = this.props;
        AuthService.logout();
        transition.router.stateService.go('login', {}, { reload: true });
    }

    render () {
        return (
            <UIView/>
        );
    }
}

export default App;
